import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMG, SERVICES } from "@/lib/api";

const EASE = [0.22, 1, 0.36, 1];
const PANELS = [
  { key: "residential", idx: "01", title: "Residential", tag: "Homes, condos, estates", img: IMG.residential, alt: "Pristine luxury residence" },
  { key: "commercial", idx: "02", title: "Commercial", tag: "Offices, retail, showrooms", img: IMG.commercial, alt: "Clean modern office" },
];

const Panel = ({ p, i }) => (
  <motion.article initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }}
    className="group flex flex-col" data-testid={`service-panel-${p.key}`}>
    <motion.div variants={{ hidden: { clipPath: "inset(0 0 100% 0)" }, show: { clipPath: "inset(0 0 0% 0)" } }}
      transition={{ duration: 1.2, delay: i * 0.15, ease: EASE }}
      className="relative aspect-[4/3] overflow-hidden bg-zinc-900">
      <img src={p.img} alt={p.alt} className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.06]" />
      <div className="absolute inset-0 bg-black/20 transition-colors duration-700 group-hover:bg-black/0" />
      <span className="absolute left-5 top-5 font-mono-x text-xs tracking-[0.2em] text-zinc-100">{p.idx} / {p.tag.toUpperCase()}</span>
    </motion.div>
    <div className="mt-8 flex items-end justify-between gap-6 border-b border-white/10 pb-6">
      <h3 className="font-display text-5xl uppercase text-zinc-50 sm:text-7xl">{p.title}</h3>
      <Link to={`/book?type=${p.key}`} data-testid={`service-book-${p.key}-button`}
        className="mb-2 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-white/20 transition-all duration-300 hover:rotate-45 hover:border-[var(--acid)] hover:bg-acid hover:text-black">
        <ArrowUpRight className="h-6 w-6" />
      </Link>
    </div>
    <ul className="mt-2">
      {SERVICES.filter((s) => s.category === p.key).map((s) => (
        <li key={s.id} className="flex flex-col gap-1 border-b border-white/10 py-5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8">
          <span className="text-lg font-semibold text-zinc-100">{s.name}</span>
          <span className="text-sm text-zinc-400 sm:max-w-[55%] sm:text-right">{s.blurb}</span>
        </li>
      ))}
    </ul>
  </motion.article>
);

export const Services = () => (
  <section id="services" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32" data-testid="services-section">
    <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <h2 className="font-display text-5xl uppercase leading-[0.9] text-zinc-50 sm:text-7xl lg:text-8xl">
        Two kinds of <br /><span className="font-serif-i normal-case text-acid">spotless.</span>
      </h2>
      <p className="max-w-sm text-base text-zinc-400">Whether it&apos;s your kitchen or your corporate HQ, the standard doesn&apos;t move. It&apos;s ridiculous. That&apos;s the point. Every job is quoted in person, because no two cleans are alike.</p>
    </div>
    <div className="grid gap-16 md:grid-cols-2 md:gap-10">
      {PANELS.map((p, i) => <Panel key={p.key} p={p} i={i} />)}
    </div>
  </section>
);
